var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNzgblogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M59,58V44h-8v14h-2V23h-8v35h-2V27h-8v31h-2V19h-8v39h-2V40h-8v18H9V35H1v23c-0.552,0-1,0.447-1,1s0.448,1,1,1h8h2h8h2h8h2 h8h2h8h2h8c0.552,0,1-0.447,1-1S59.552,58,59,58z M7,37v7H3v-7H7z M3,58V46h4v12H3z M17,42v7h-4v-7H17z M13,58v-7h4v7H13z M27,21v7 h-4v-7H27z M23,58V30h4v28H23z M37,29v7h-4v-7H37z M33,58V38h4v20H33z M47,25v15h-4V25H47z M43,58V42h4v16H43z M57,46v5h-4v-5H57z  M53,58v-5h4v5H53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,2h58c0.552,0,1-0.447,1-1s-0.448-1-1-1H1C0.448,0,0,0.447,0,1S0.448,2,1,2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,13h8c0.552,0,1-0.447,1-1s-0.448-1-1-1h-8c-0.552,0-1,0.447-1,1S43.448,13,44,13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.29,11.29C56.11,11.479,56,11.729,56,12c0,0.27,0.11,0.52,0.29,0.71C56.48,12.89,56.74,13,57,13 c0.26,0,0.52-0.11,0.71-0.29C57.89,12.52,58,12.26,58,12c0-0.271-0.11-0.521-0.29-0.71C57.33,10.92,56.66,10.92,56.29,11.29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,6h-3c-0.552,0-1,0.447-1,1s0.448,1,1,1h3c0.552,0,1-0.447,1-1S57.552,6,57,6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,8h2c0.552,0,1-0.447,1-1s-0.448-1-1-1h-2c-0.552,0-1,0.447-1,1S43.448,8,44,8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.71,7.71C50.89,7.52,51,7.26,51,7s-0.11-0.521-0.29-0.71c-0.37-0.37-1.04-0.37-1.42,0C49.11,6.479,49,6.729,49,7 c0,0.26,0.11,0.52,0.29,0.71C49.48,7.89,49.74,8,50,8C50.27,8,50.52,7.89,50.71,7.71z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNzgblogo);
export default __webpack_public_path__ + "static/media/nzgblogo.5d535808b6922b9368d709fb5ab3c8c2.svg";
export { ForwardRef as ReactComponent };